import React, { createContext, useContext, useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Theme Context
export const ThemeContext = createContext({
  darkMode: true,
  toggleDarkMode: () => {}
});

export const useTheme = () => useContext(ThemeContext);

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('portfolio-theme');
    return saved ? saved === 'dark' : true;
  });

  // Hide Emergent badge
  useEffect(() => {
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.setProperty('display', 'none', 'important');
  }, []);

  useEffect(() => {
    localStorage.setItem('portfolio-theme', darkMode ? 'dark' : 'light');
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(prev => !prev);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <BrowserRouter>
        <div className={`portfolio-app ${darkMode ? 'dark' : 'light'}`}>
          <Header />
          <main>
            <Hero />
            <Portfolio />
            <About />
            <Skills />
            <Contact />
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </div>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
}

export default App;
